import { get } from "lodash";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Suspense } from "react";
import Loader from "../../components/Loader";
import { t } from "i18next";
import { GetStaticPropsContext } from "next";
import { Authenticated } from "@qure/qure-auth";

const Patients = dynamic(() => import("../../components/Patients"), {
  ssr: false,
  loading: () => (
    <div className="flex items-center justify-center bold text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-900 w-full h-full">
      <Loader size="medium" label={`${t("loading_key")}...`} />
    </div>
  ),
});

const PatientsPage = () => {
  const router = useRouter();
  const patient_uid = Number(get(router, ["query", "params", "0"], 0));

  return (
    <Suspense fallback={`${t("loading_key")}...`}>
      <Authenticated>
        <Patients patient_uid={patient_uid} />
      </Authenticated>
    </Suspense>
  );
};

export async function getStaticProps(context: GetStaticPropsContext) {
  return {
    props: {
      hasShare: !!context?.params?.length ? true : false,
    },
  };
}

export const getStaticPaths = () => {
  return {
    paths: [], //indicates that no page needs be created at build time
    fallback: "blocking", //indicates the type of fallback
  };
};

export default PatientsPage;
